import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

const TEST_KEY = '__local_storage_test__';

function LocalStorageFacade() {
	function isSupported(): boolean {
		try {
			AtlBrowserStorageLocal.setItem(TEST_KEY, TEST_KEY);
			AtlBrowserStorageLocal.removeItem(TEST_KEY);
			return true;
		} catch (e) {
			return false;
		}
	}

	function setItem(key: string, value: string): void {
		if (!isSupported()) {
			return;
		}

		AtlBrowserStorageLocal.setItem(key, value);
	}

	function getItem<T extends string>(key: string): T | null {
		if (!isSupported()) {
			return null;
		}
		return AtlBrowserStorageLocal.getItem(key) as T;
	}

	function removeItem(key: string): void | null {
		if (!isSupported()) {
			return null;
		}
		return AtlBrowserStorageLocal.removeItem(key);
	}

	return {
		isSupported,
		getItem,
		setItem,
		removeItem,
	};
}

const _default_1: {
	isSupported: () => boolean;
	getItem: <T extends string>(key: string) => T | null;
	setItem: (key: string, value: string) => void;
	removeItem: (key: string) => void | null;
} = LocalStorageFacade();
export default _default_1;
